import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SectionHeader from 'components/shared/landing/section-header';
import TeamMembers from './team-members';
import Partners from './partners';
import styles from './styles.module.scss';

const AboutUnyted = () => (
  <div className={styles.aboutUnyted}>
    <section className={styles.mission}>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h5>what we believe in</h5>
            <h2>Our Vision</h2>
            <div className={styles.visionQuote}>
              <FontAwesomeIcon
                className={styles.quoteLeft}
                icon="quote-left"
                size="2x"
              />
              <p className={styles.visionQuote}>
                The best way to connect learning and development to the real
                world.
              </p>
              <FontAwesomeIcon
                className={styles.quoteRight}
                icon="quote-right"
                size="2x"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className={styles.team}>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <SectionHeader tagline="who we are" valueprop="Founding Team" />
          </div>
        </div>
        <div className="row mt-2 justify-content-center">
          <div className="col-12">
            <TeamMembers />
          </div>
        </div>
      </div>
    </section>
    <section className={styles.schools}>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <SectionHeader
              tagline="examples of cutting edge schools"
              valueprop="Our Partners"
            />
          </div>
        </div>
        <div className="row">
          <Partners />
        </div>
      </div>
    </section>
  </div>
);

export default AboutUnyted;
